module.exports = __webpack_public_path__ + "static/media/honey-face-wash.db0d8d65.jpg";